<template>
  <div class="container">
    <div class="filter-block">
      <el-input-number v-model="search_uid" size="small" placeholder="输入UID"/>
      <el-date-picker
        v-model="search_time"
        type="daterange"
        size="small"
        value-format="yyyy-MM-dd HH:mm:ss"
        class="margin-30"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      ></el-date-picker>
      <el-button size="small" type="primary" @click="handleSearch">筛选</el-button>
    </div>
    <el-table
      :data="dataList"
      @filter-change="handleFilterStatus"
      @sort-change="handleSort"
    >
      <el-table-column
        prop="id"
        label="ID"
        sortable="custom"
      />
      <el-table-column
        prop="user_id"
        label="UID"
      />
      <el-table-column
        prop="nickname"
        label="用户昵称"
      />
      <el-table-column
        prop="avatar"
        label="用户头像"
      >
        <template slot-scope="s">
          <el-image
            :src="s.row.avatar || ''"
            style="width: 40px; height: 40px;"
          />
        </template>
      </el-table-column>
      <el-table-column prop="channel" label="渠道"/>
      <el-table-column
        prop="status"
        label="状态"
        :filters="[
          {text: '已创建', value: 0},
          {text: '待支付', value: 50},
          {text: '已支付', value: 100},
          {text: '待使用', value: 730},
          {text: '已完成', value: 999},
        ]"
      >
        <template slot-scope="scope">
          {{status_map[scope.row.status] || '未知'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="price"
        label="总价"
      >
        <template slot-scope="scope">
          {{scope.row['price'] / 100}}元
        </template>
      </el-table-column>
      <el-table-column
        prop="pay_type"
        label="支付类型"
      >
        <template slot-scope="scope">
          {{pay_type_map[ scope.row['pay_type'] ] || '未知'}}
        </template>
      </el-table-column>
      <el-table-column
        prop="pay_id"
        label="支付ID"
      />
      <el-table-column
        prop="time"
        label="创建时间"
      />

    </el-table>
    <pager
      api="order_list"
      model="shop"
      :defaultPageSize=50
      :sort="sort"
      :filter="filter"
      @data-changed="onDataChanged"
    />
  </div>
</template>
<script>
  import Pager from "../ui/Pager"

  export default {
    name: 'OrderList',
    components: {
      Pager
    },
    data: () => {
      return {
        dataList: [],
        sort: [
          {
            field: 'id',
            reverse: true
          }
        ],
        filter: {},
        search_uid: null,
        search_time: [],
        search_status: 0,
        channel: null,
        pickerOptions: {
          shortcuts: [
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              }
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              }
            }
          ]
        },
        status_map: {
          '0': '已创建',
          '50': '待支付',
          '100': '已支付',
          '730': '待使用',
          '990': '超时关闭',
          '998': '使用失败',
          '999': '完成'
        },
        pay_type_map: {
          'a': '在线支付',
          'c': '积分支付',
          'w': '余额支付',
        }
      }
    },
    created() {
      if (this.$route.params.channel) {
        this.filter.channel = parseInt(this.$route.params.channel)
      }
      if (this.$route.params.date) {
        this.search_time[0] = this.$route.params.date + ' 00:00:00'
        this.search_time[1] = this.$route.params.date + ' 00:00:00'
        this.filter.time = [
          this.$route.params.date + ' 00:00:00',
          this.$route.params.date + ' 23:59:59',
        ];
      }
    },
    methods: {
      onDataChanged: function (list) {
        this.dataList = list
      },
      handleSearch: function () {
        let filter = {}

        if (this.search_time[0] && this.search_time[1]) {
          filter.time = [
            this.search_time[0].split(' ')[0] + ' 00:00:00',
            this.search_time[1].split(' ')[0] + ' 23:59:59',
          ];
        }
        if (this.search_uid) {
          filter.user_id = this.search_uid
        }
        if (this.search_status) {
          filter.status = this.search_status
        }

        this.filter = filter
      },
      handleSort: function (column) {
        console.log(column)
        const sort = [{
          field: column.prop,
          reverse: column.order === 'descending'
        }];
        this.sort = sort
      },
      handleFilterStatus: function (ev) {
        this.search_status = ev['el-table_1_column_3']
        this.handleSearch()
      }
    }
  }
</script>
